import { render, staticRenderFns } from "./AStatusChanger.vue?vue&type=template&id=f35b8e92"
import script from "./AStatusChanger.vue?vue&type=script&lang=js"
export * from "./AStatusChanger.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports